export default class {
	static WEEK_DAYS = Object.freeze(["日", "月", "火", "水", "木", "金", "土"])

	static MODE = Object.freeze({
		Year: "year",
		Month: "month",
		Date: "date",
		Time: "time",
		DateTime: "datetime"
	})
}
